import { Injectable } from '@angular/core';
import {
    FormGroup,
    ValidatorFn
} from '@angular/forms';
import {
    IDatiqInput,
    IDatiqInputValidatorService,
} from '@dat/datiq-components-pkg/utils';
import { DatiqInputValidatorsText } from '../validators';

@Injectable({
    providedIn: 'root',
})
export class DatiqInputTextGeoValidatorService
    implements IDatiqInputValidatorService
{
    constructor() {}
    addValidator(
        settings: IDatiqInput,
        validations: ValidatorFn[],
        formGroup?: FormGroup<any>
    ): ValidatorFn[] {
        return [
            ...validations,
            DatiqInputValidatorsText.geoIndeterminate(settings),
        ];
    }
}
